var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 33.3332C5.16732 33.3332 4.58398 33.0762 4.08398 32.5623C3.58398 32.0484 3.33398 31.4721 3.33398 30.8332V9.1665C3.33398 8.52761 3.58398 7.95123 4.08398 7.43734C4.58398 6.92345 5.16732 6.6665 5.83398 6.6665H17.5423L20.0423 9.1665H34.1673C34.8062 9.1665 35.3826 9.42345 35.8965 9.93734C36.4104 10.4512 36.6673 11.0276 36.6673 11.6665V30.8332C36.6673 31.4721 36.4104 32.0484 35.8965 32.5623C35.3826 33.0762 34.8062 33.3332 34.1673 33.3332H5.83398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFolder);
export default __webpack_public_path__ + "static/media/closeFolder.2caab420b4097e6d2c0435cca9e7882c.svg";
export { ForwardRef as ReactComponent };